import { Box, Typography } from "@mui/material";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

export default function CategoryCard({
  label,
  img,
  onClick,
  active,
  showArrow = true,
  objfit = "cover",
  imgPadding = 0,
  imgBg = "transparent",
  imgPosition = "center",
  labelWidth = "75%",
  labelPlacement = "bottom",
  labelAlign = "center",
  aspectRatio = "16 / 10",
  overlayLabel = false,
  overlayLabelFontSize = { xs: 15, sm: 18, md: 20 },
  overlayLabelAlign = "center",
  overlayLabelPlayIcon = false,
}) {
  const isLabelTop = labelPlacement === "top";

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: onClick ? "pointer" : "default",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: "filter .18s ease",
        "&:hover": onClick ? { filter: "brightness(0.98)" } : undefined,
        "&:hover .cat-label": onClick
          ? overlayLabel
            ? {
                transform:
                  overlayLabelAlign === "left"
                    ? "scale(1.03)"
                    : "translateX(-50%) scale(1.03)",
              }
            : { transform: "scale(1.03)" }
          : undefined,
      }}
    >
      {isLabelTop && !overlayLabel && (
        <Typography
          className="cat-label"
          sx={{
            width: labelWidth,
            textAlign: labelAlign,
            fontSize: 18,
            fontWeight: 700,
            display: "flex",
            justifyContent:
              labelAlign === "left"
                ? "flex-start"
                : labelAlign === "right"
                  ? "flex-end"
                  : "center",
            alignItems: "center",
            gap: 0.25,
            mb: 0.75,
            transition: "transform .18s ease, color .18s ease",
            transform: "scale(1)",
            color: active ? "text.primary" : "text.secondary",
          }}
        >
          {label}
          {showArrow && <span>›</span>}
        </Typography>
      )}

      <Box
        sx={{
          width: "100%",
          aspectRatio,
          borderRadius: 1,
          overflow: "hidden",
          position: "relative",
          mb: isLabelTop && !overlayLabel ? 0 : 0.75,
          border: "3px solid",
          borderColor: active ? "#e78a20" : "transparent",
          transition:
            "box-shadow .18s ease, border-color .18s ease, transform .18s ease",
          boxSizing: "border-box",
        }}
      >
        {img && (
          <Box
            component="img"
            src={img}
            alt={label}
            className="cat-img"
            data-eager="1"
            loading="eager"
            fetchPriority="auto"
            decoding="sync"
            onLoad={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
            sx={{
              width: "100%",
              height: "100%",
              display: "block",
              objectFit: "cover",
              objectPosition: imgPosition,
              opacity: 1,
              visibility: "visible",
            }}
          />
        )}

        {overlayLabel && (
          <Typography
            className="cat-label"
            sx={{
              position: "absolute",
              left: overlayLabelAlign === "left" ? 0 : "50%",
              bottom: 5,
              zIndex: 2,
              px: 1.5,
              py: 0.5,
              borderRadius: "999px",
              fontSize: overlayLabelFontSize,
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent:
                overlayLabelAlign === "left" ? "flex-start" : "center",
              textAlign: overlayLabelAlign,
              gap: 0.5,
              transition: "transform .18s ease, color .18s ease",
              transform:
                overlayLabelAlign === "left"
                  ? "scale(1)"
                  : "translateX(-50%) scale(1)",
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >
            {label}
            {overlayLabelPlayIcon && (
                <PlayCircleIcon
                  sx={{
                    fontSize: { xs: 18, sm: 35, md: 25, lg: 25 },
                    color: "#ffff",
                  }}
                />
            )}
          </Typography>
        )}
      </Box>

      {!isLabelTop && !overlayLabel && (
        <Typography
          className="cat-label"
          sx={{
            width: labelWidth,
            textAlign: labelAlign,
            fontSize: 18,
            fontWeight: 700,
            display: "flex",
            justifyContent:
              labelAlign === "left"
                ? "flex-start"
                : labelAlign === "right"
                  ? "flex-end"
                  : "center",
            alignItems: "center",
            gap: 0.25,
            transition: "transform .18s ease, color .18s ease",
            transform: "scale(1)",
            color: active ? "text.primary" : "text.secondary",
          }}
        >
          {label}
          {showArrow && <span>›</span>}
        </Typography>
      )}
    </Box>
  );
}
